import { assetUrl } from "../utils/sitePaths.js";

export default function PageHero({ eyebrow, title, text, image = "/images/premium-powders.jpg" }) {
  return (
    <section className="page-hero">
      <div className="section-inner page-hero-grid">
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          {text && <p className="hero-copy">{text}</p>}
        </div>
        <figure>
          <img src={assetUrl(image)} alt="" />
        </figure>
      </div>
    </section>
  );
}
